import React from 'react'
import { Trans } from '../../atoms'
import Link from 'next/link'

import MyImage from '../../atoms/MyImage/MyImage'
import useTrans from '../../../hooks/useTrans'
import { useRouter } from 'next/router'
import { isPdf } from '../../../utils/pdf'
import { getAltText } from '../../../utils/safe'

const ProdottoInfo = ({ prodotto, isPrenotato, fromPdf }) => {
  const t = useTrans()
  const router = useRouter()
  return (
    <div className="prodotto-info">
      <Link href={prodotto.url}>
        {fromPdf || isPdf(router) ? (
          <img
            src={prodotto.thumb_image?.url || prodotto.image?.url}
            alt={prodotto.titolo}
            className={'prodotto-info__image'}
          />
        ) : (
          <MyImage
            width={86}
            height={86}
            src={prodotto.image?.url}
            alt={getAltText(prodotto.image) || prodotto.titolo}
            layout={'intrinsic'}
            className={'prodotto-info__image'}
          />
        )}
      </Link>
      {isPrenotato && <div className="prodotto-info__etichetta">{t('Prenotata')}</div>}
      <div className="prodotto-info__main">
        <div>
          <Link href={prodotto.url}>
            <strong>{prodotto.codice}</strong>
          </Link>
          {prodotto?.nome && <p className="prodotto-side-cart__nome">{prodotto.nome}</p>}
          <p className="prodotto-info__descrizione">{prodotto.titolo}</p>
        </div>
        <div>
          <p className="prodotto-info__data">
            <span className="prodotto-info__data-label">{t('Colore')}:</span>{' '}
            <span className="prodotto-info__data-value">{prodotto.colore}</span>
          </p>
          {prodotto.taglia && (
            <p className="prodotto-info__data">
              <span className="prodotto-info__data-label">{t('Taglia')}:</span>{' '}
              <span className="prodotto-info__data-value">{prodotto.taglia}</span>
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

export default ProdottoInfo
